import { TitleLightWithSelectedParent } from '@warehouse/title/core';
import { GridColDef } from '@mui/x-data-grid-pro';

export function DistributionNumberColumnDataGrid<T extends TitleLightWithSelectedParent>(): GridColDef<T, string> {
	return {
		headerName: 'Distribution Number',
		field: 'distributionNumber',
		renderCell: (params) => params.row.selectedParent.sequenceInfo.distributionNumber || '',
		editable: false,
		type: 'string',
		minWidth: 160,
		flex: 0.5,
	};
}

export function HouseSequenceColumnDataGrid<T extends TitleLightWithSelectedParent>(): GridColDef<T, string> {
	return {
		headerName: 'House Sequence',
		field: 'houseSequence',
		renderCell: (params) => params.row.selectedParent.sequenceInfo.houseSequence || '',
		type: 'string',
		editable: false,
		minWidth: 140,
		flex: 0.5,
	};
}
